module.exports = __webpack_public_path__ + "img/linkedin-icon.52e7ebda.svg";